import router from '@/router';
// 设置标签
const tags = [];
const tagCallbacks = [];
export function useTag(callback) {
  if (callback) {
    tagCallbacks.push(callback);
  }
}
export function createTag(tag) {
  const newTag = router.matcher.match(tag, router);
  tag.path = newTag.path;
  tag.fullPath = newTag.fullPath;
  tag.params = newTag.params;
  const activeIndex = tags.findIndex((item) => item.path === tag.path);
  if (activeIndex > -1) {
    tags.splice(activeIndex, 1);
  }
  tags.push(tag);
  tagCallbacks.forEach((callback) => {
    callback(JSON.parse(JSON.stringify(tags)));
  });
}
